import { inject } from "@angular/core";
import { CanDeactivateFn } from "@angular/router";
import { APP_CONFIG_TOKEN } from "@kno2/core/config";
import { MessagesService } from "@kno2/data-access/messages";
import { ConfirmationDialogService } from "@kno2/shared/confirmation-dialog";
import { MessageFormManagerService } from "../message/shared";
import { ReleaseNewComponent } from "./new/release-new.component";

export const releaseDraftGuard: CanDeactivateFn<ReleaseNewComponent> = async (component: ReleaseNewComponent) => {
    const appConfig = inject(APP_CONFIG_TOKEN);
    const messagesService = inject(MessagesService);
    const messageFormManagerService = inject(MessageFormManagerService);
    const confirmationDialogService = inject(ConfirmationDialogService);

    const hasUnsavedChanged = messageFormManagerService.hasUnsavedChanges();

    if (hasUnsavedChanged) {
        return new Promise<boolean>((resolve) => {
            confirmationDialogService.open({
                headerText: "Save Draft",
                bodyText: "Would you like to save your draft?",
                cancelText: "Discard",
                okText: "Save",
                confirmFn: async () => {
                    try {
                        const payload = messageFormManagerService.mapFormToMessage(component.patientIntegrationMeta(), component.attachments);
                        await messagesService.saveDraft({
                            ...payload,
                            origin: appConfig.brand
                        });
                        resolve(true);
                    } catch {
                        resolve(false);
                    }
                },
                cancelFn: async () => {
                    try {
                        const messageId = component.form.get("id").value;
                        if (messageId) {
                            await messagesService.deleteMessage(messageId);
                        }
                        resolve(true);
                    } catch {
                        resolve(false);
                    }
                },
                dismissFn: () => resolve(false)
            });
        });
    }
    return true;
};
